(function($) {

  /**
   * window, wrapper
   * @type {*|HTMLElement}
   */
  var $win = $(window),
    $wrapper = $('[data-page="wrapper"]');

  /**
   * touch判定
   * @returns {boolean}
   */
  var isTouch = function() {
    var hasTouchEvent = ('ontouchstart' in window);
    var ua = window.navigator.userAgent.toLowerCase();

    return (/ip(hone|od)/.test(ua) || /android/.test(ua)) && hasTouchEvent
  };

  /**
   * globalMenu
   */
  var globalMenu = function() {

    var GlobalMenu = (function() {

      // const
      var SHOW_CLASS = 'is-show';
      var OPEN_CLASS = 'is-open';
      var MENU_CLASS = 'is-menu';

      function GlobalMenu() {
        this.$trigger = $('[data-global-menu="trigger"]');
        this.$target = $('[data-global-menu="target"]');
        this.$scroll = $('[data-global-menu="scroll"]');
        this.$close = $('[data-global-menu="close"]');
        this.$bg = $('[data-global-menu="bg"]');

        this.isTouch = isTouch();
        this.isShowMenu = false;
        this.touchStartY = 0;
        this.scrollTop = 0;

        this.onTouchMove = this.onTouchMove.bind(this);
      }

      GlobalMenu.prototype.init = function() {
        var _self = this;

        this.$trigger.on('click', function() {
          _self.showMenu();
        });

        this.$close.on('click', function() {
          _self.hideMenu();
        });

        this.$bg.on('click', function() {
          _self.hideMenu();
        });

        if (this.isTouch) {
          window.addEventListener('touchstart', function(event) {
            if (!_self.isShowMenu) {
              return;
            }
            _self.touchStartY = event.touches[0].clientY;
          }, { passive: false });

          window.addEventListener('touchmove', this.onTouchMove, { passive: false });
        }
      };

      GlobalMenu.prototype.onTouchMove = function(event) {
        var _self = this;

        if (!_self.isShowMenu) {
          return;
        }

        var currentY = event.touches[0].clientY,
          height = _self.$scroll.outerHeight(),
          isTop = this.touchStartY <= currentY && _self.$scroll[0].scrollTop === 0,
          isBottom = this.touchStartY >= currentY && _self.$scroll[0].scrollHeight - _self.$scroll[0].scrollTop === height;

        // スクロール対応モーダルの上端または下端のとき
        if (isTop || isBottom) {
          // スクロール禁止
          event.preventDefault();
        }
      };

      GlobalMenu.prototype.showMenu = function() {
        var _self = this;

        this.isShowMenu = true;
        this.scrollTop = $win.scrollTop();
        $wrapper.css('margin-top', -this.scrollTop);

        setTimeout(function() {
          _self.$target.addClass(SHOW_CLASS);
        }, 10);

        setTimeout(function() {
          _self.$target.addClass(OPEN_CLASS);
        }, 200);

        $wrapper.addClass(MENU_CLASS);
      };

      GlobalMenu.prototype.hideMenu = function() {
        var _self = this;

        this.isShowMenu = false;
        this.$target.removeClass(OPEN_CLASS);

        setTimeout(function() {
          _self.$target.removeClass(SHOW_CLASS);
          $wrapper.removeAttr('style');
          $win.scrollTop(_self.scrollTop);
          _self.scrollTop = 0;
        }, 400);

        $wrapper.removeClass(MENU_CLASS);

        if (this.isTouch) {
          window.removeEventListener('touchmove', this.onTouchMove, { passive: false })
        }
      };

      return GlobalMenu;
    })();

    new GlobalMenu().init();
  };

  /**
   * document ready
   */
  $(function() {
    globalMenu();
  });
})(jQuery);